import { render, staticRenderFns } from "./ConsentConfigModal.vue?vue&type=template&id=e58d4caa&scoped=true"
import script from "./ConsentConfigModal.vue?vue&type=script&lang=js"
export * from "./ConsentConfigModal.vue?vue&type=script&lang=js"
import style0 from "./ConsentConfigModal.vue?vue&type=style&index=0&id=e58d4caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e58d4caa",
  null
  
)

export default component.exports